import { AppBar, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Fade, FormControl, FormControlLabel, FormLabel, Grid, IconButton, LinearProgress, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, MenuItem, Radio, RadioGroup, TextField, Theme, Tooltip, Typography, createStyles, makeStyles, useTheme } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { ArrowBack, Assignment, Layers, OpenInNew, Repeat, Save, Search } from '@material-ui/icons';
import { Alert, Autocomplete } from '@material-ui/lab';
import { useSnackbar } from 'notistack';
import React from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { CurrencyInput } from '../../components/CurrencyInput';
import ResumoDrawer from '../../components/ResumoDrawer';
import Page from '../../containers/Page/Page';
import { useAuth } from '../../hooks/auth';
import { useLoading } from '../../hooks/loading';
import { usePermissions } from '../../hooks/permissions';
import { api } from '../../services/api';
import { IResumo } from '../../types/Resumo';
import { Helpers } from '../../utils/Helpers';

interface ICaracteristica {
    id: string;
    label: string;
    preenchido: string;
    preenchido_original: string;
    input: string;
    grupo: boolean;
    peso_base: boolean;
    proximo: boolean;
    tentou_herdar: string;
    sem_heranca: string;
    valores: {
        valor: string;
    }[];
    custom: {
        valor: string;
    }[];
}

interface IAcessorio {
    id: string;
    codigo_sap: string;
    tamanho: string;
    modelo: string;
    modelo_id: string;
    modelo_bomba: string;
    classificacao_bomba: string;
    isBase: boolean;
    caracteristicas: ICaracteristica[];
    proxima_caracteristica: ICaracteristica;
    is_snapshot: boolean;
    apenas_terceiros: boolean;
    permite_alterar: boolean;
    status: string;
    pai: string;
    tipo_pai: string;
    filho: string;
}

interface IComposto {
    descricao: string;
    campos: ICompostoCampo[];
}

interface ICompostoCampo {
    nome: string;
    tipo: string;
    afunila: boolean;
    preenchido: string;
    opcoes: {
        opcao: string;
    }[];
}

interface IEscopo {
    id: string;
    tamanho: string;
    contador: string;
    modelo: {
        id: string;
        nome: string;
    };
    modelos: {
        pivot: {
            id: string;
        }
    }[];
}

interface ITabela {
    moeda: string;
    lista_convertido: string;
    lista_descadc: string;
    lista_taxa_reais: string;
    lista_fatdesc: string;
    lista_preco: string;
    lista_precoliq: string;
    lista_variantes: string;
    terceiros_fornecedor: string;
    terceiros_referencia: string;
    terceiros_bruto: string;
    terceiros_taxa_reais: string;
    terceiros_precoun: string;
    terceiros_descforn: string;
    terceiros_desc_adicional: string;
    terceiros_fatdesc: string;
    terceiros_icmsret: string;
    terceiros_piscofinsret: string;
    terceiros_margem_revenda: string;
    terceiros_fatimp: string;
    terceiros_liquido: string;
}

interface IImpostos {
    qtd: string;
    fator_vendas: string;
    fator_custo: string;
    fat_enc: string;
    tipo_preco: string;
}

interface IDescontos {
    lista_desc_inf_comercial: string;
    lista_desc_cliente: string;
    cpp_desc_inf_comercial: string;
    cpp_desc_cliente: string;
    terceiros_desc_inf_comercial: string;
    terceiros_desc_cliente: string;
    desc_cliente_original: string;
    desc_j: string;
    desc5: boolean;
}

interface IConversao {
    brl: string;
    eur: string;
    upk: string;
    usd: string;
}

interface IVariante {
    id: string;
    label: string;
    tipo: string;
    opcoes: {
        id: string;
        opcao: string;
    }[];
    selecionado?: string;
}

interface IParams {
    id: string;
    modelo: string;
    acessorio: string;
}

function PropostasAcessoriosModelo() {

    //Hooks
    const history = useHistory();
    const classes = useStyles();
    const theme = useTheme();
    const params = useParams<IParams>();
    const permissions = usePermissions();
    const { data } = useAuth();

    //Loading
    const { startLoading, stopLoading, isLoading } = useLoading();

    //Alert
    const { enqueueSnackbar: alert } = useSnackbar();

    //States
    const [error, setError] = React.useState<string>('');
    const [loadingCount, setLoadingCount] = React.useState<number>(0);
    const [acessorio, setAcessorio] = React.useState<IAcessorio>({} as IAcessorio);
    const [tabela, setTabela] = React.useState<ITabela>({} as ITabela);
    const [impostos, setImpostos] = React.useState<IImpostos>({} as IImpostos);
    const [descontos, setDescontos] = React.useState<IDescontos>({} as IDescontos);
    const [resumo, setResumo] = React.useState<IResumo>({} as IResumo);
    const [resumoError, setResumoError] = React.useState<string>('');
    const [resumoDrawer, setResumoDrawer] = React.useState<boolean>(false);
    const [buscarDialog, setBuscarDialog] = React.useState<boolean>(false);
    const [precoResponse, setPrecoResponse] = React.useState<boolean>(false);
    const [variante, setVariante] = React.useState<boolean>(false);
    const [varianteTipo, setVarianteTipo] = React.useState<string>('');
    const [variantes, setVariantes] = React.useState<IVariante[]>([]);
    const [conversao, setConversao] = React.useState<IConversao>({} as IConversao);
    const [composto, setComposto] = React.useState<boolean>(false);
    const [compostos, setCompostos] = React.useState<IComposto[]>([]);
    const [buscarCompostoDialog, setBuscarCompostoDialog] = React.useState<boolean>(false);
    const [escopos, setEscopos] = React.useState<IEscopo[]>([]);
    const [escopoDialog, setEscopoDialog] = React.useState<boolean>(false);
    const [escopoSelection, setEscopoSelection] = React.useState<string>('');

    const loading = loadingCount > 0;

    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        handleFetchEscopos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acessorio.modelo_id]);

    React.useEffect(() => {
        handleFetchResumo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        setTabela({
            ...tabela,
            moeda: "R$",
            terceiros_icmsret: '0',
            terceiros_piscofinsret: '0',
            terceiros_margem_revenda: '65',
            terceiros_fatimp: '1'
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const tiposPrecos = {
        "KSB": "Lista KSB",
        "Terceiros": "Cotação"
    }

    async function handleFetch(value: IAcessorio = acessorio) {
        setLoadingCount(c => c + 1);
        try {
            const response = await api.post(`propostas/${params.modelo}/acessorio/${params.acessorio}`, {
                ...value,
                ...impostos
            });
            const { object } = response.data;
            setAcessorio(getAcessorioWithOriginal(object));
            setVariante(object.variantes);
            setVarianteTipo(object.tipo_variante);
            setComposto(object.composto);
            if (object.preco) setTabela(object.preco);
            if (object.preco) setPrecoResponse(true);
            if (object.impostos) setImpostos(object.impostos);
            if (object.descontos) setDescontos(object.descontos);
            if (object.variantes) setVariantes(object.variantes_selecionadas);
            if (object.composto) setCompostos(object.variantes_selecionadas);
            if (object.conversao) setConversao(object.conversao);
            if (object.impostos.tipo_preco === 'KSB' && object.codigo_sap && !Boolean(object.isBase)) {
                await handleSearchPreco(object.impostos, object, object.descontos, object.conversao);
            }
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleFetchChange(value: IAcessorio = acessorio) {
        startLoading('afunilamento')
        try {
            const response = await api.post(`propostas/${params.modelo}/acessorio/${params.acessorio}`, {
                ...value,
                ...impostos
            });
            const { object } = response.data;
            setAcessorio(getAcessorioWithOriginal(object));
            setImpostos(object.impostos);
            await handleVerifyPreco(object);
        } catch (error: any) {
            Helpers.error(error, alert);
        } finally {
            stopLoading('afunilamento');
        }
    }

    async function handleFetchPesoBase() {
        if (Boolean(acessorio.isBase) && (isNaNOrUndefined(getPesoBase()) || getValue(getPesoBase()) === 0)) {
            alert('É necessário informar um peso base válido', { variant: 'warning' });
        } else {
            await handleFetch();
        }
    }

    async function handleFetchResumo() {
        setLoadingCount(c => c + 1);
        try {
            const response = await api.get(`resumo/${params.modelo}`);
            setResumo(response.data.object);
            setResumoError('');
        } catch (error: any) {
            setResumoError(Helpers.errorFormat(error));
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleCheckPreco() {
        if ((tabela.lista_preco && !Boolean(acessorio.isBase)) || (tabela.lista_preco && isBaseValid())) {
            setBuscarDialog(true);
        } else if (!isBaseValid()) {
            alert('É necessário informar um peso base válido', { variant: 'warning' });
        } else {
            await handleSearchPreco();
        }
    }

    async function handleVerifyPreco(object: any) {
        if (object.impostos.tipo_preco === 'KSB' && object.codigo_sap && !Boolean(object.isBase)) {
            await handleSearchPreco(object.impostos, object, object.descontos, object.conversao);
        } else if (object.impostos.tipo_preco === 'Terceiros') {
            resetPreco();
            setPrecoResponse(true);
        }
    }

    async function handleSearchPreco(imp: IImpostos = impostos, acs: IAcessorio = acessorio, dsc: IDescontos = descontos, cnv: IConversao = conversao) {
        startLoading('preco');
        try {
            //Buscar Preço
            const response = await api.post('/precos', {
                tipo: imp.tipo_preco,
                tipo_variante: varianteTipo,
                classificacao_bomba: acs.classificacao_bomba,
                codigo_sap: acs.codigo_sap,
                proposta_id: params.id,
                modelo_proposta_id: params.modelo,
                modelo_acessorio: params.acessorio,
                mercado: data.user.mercado,
                peso_base: getPesoBase()
            });

            //Objeto
            const { preco, variantes } = response.data;

            //States
            setTabela(preco);
            setVariantes(variantes);
            setImpostos({
                ...imp,
                fator_custo: preco.fator_custo,
                fator_vendas: preco.fator_vendas
            });

            //Auto-Save
            await api.post(`precos/${params.modelo}/acessorio/${params.acessorio}`, {
                ...imp,
                ...preco,
                ...descontos,
                fator_custo: preco.fator_custo,
                fator_vendas: preco.fator_vendas,
                lista_precoliq: getPrecoLiqKSB(preco, imp, dsc, cnv),
                lista_convertido: getConvertidoKSB(preco, cnv),
                lista_fatdesc: getFatDescKSB(dsc),
                lista_taxa_reais: getTaxaMoeda(preco.moeda, cnv),
                terceiros_precoun: getPrecoLiqTer(preco, imp, dsc, cnv),
                terceiros_liquido: getPrecoBrutoSemImpostosTer(preco),
                terceiros_fatdesc: getFatDescTer(dsc),
                terceiros_taxa_reais: getTaxaMoeda(preco.moeda, cnv),
            });

            //Sucesso
            setPrecoResponse(true);
        } catch (error) {
            Helpers.error(error, alert);
            setPrecoResponse(false);
        } finally {
            stopLoading('preco');
        }
    }

    async function handleCheckComposto() {
        if (compostos && compostos.length > 0) {
            setBuscarCompostoDialog(true);
        } else {
            await handleFetchComposto();
        }
    }

    async function handleFetchComposto() {
        setBuscarCompostoDialog(false);
        setLoadingCount(c => c + 1);
        try {
            const response = await api.post('compostos', {
                ...acessorio,
                proposta_modelo: params.modelo,
                modelo_acessorio: params.acessorio
            });
            setCompostos(response.data);
            resetPreco();
            setPrecoResponse(true);
        } catch (error) {
            Helpers.error(error, alert);
            setPrecoResponse(false);
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleFetchEscopos() {
        startLoading('escopos');
        try {
            const response = await api.get(`propostas/${params.acessorio}/escopos`);
            setEscopos(response.data.object);
        } catch (error) {
            Helpers.error(error, alert);
        } finally {
            stopLoading('escopos');
        }
    }

    async function handleOpenVariante() {
        startLoading('variante');
        try {
            const response = await api.post(`propostas/${params.modelo}/filho/${acessorio.modelo_id}`, {
                modelo_id: acessorio.filho
            });
            history.push(`/propostas/${params.id}/modelo/${params.modelo}/acessorios/${response.data.object}`);
            window.location.reload();
        } catch (error) {
            Helpers.error(error, alert);
        } finally {
            stopLoading('variante');
        }
    }

    async function handleOpenVariantePai() {
        const url = acessorio.tipo_pai === 'BOMBA'
            ? `/propostas/${params.id}/modelo/${acessorio.pai}`
            : `/propostas/${params.id}/modelo/${params.modelo}/acessorios/${acessorio.pai}`;
        history.push(url);
        window.location.reload();
    }

    async function handleReset() {
        setLoadingCount(c => c + 1);
        try {
            const response = await api.post(`propostas/snapshot/${params.acessorio}/acessorio/0`);
            setAcessorio({ ...acessorio, is_snapshot: false });
            await handleFetch({} as IAcessorio);
            alert(response.data.message, { variant: 'success' });
        } catch (error) {
            Helpers.error(error, alert);
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleSave() {
        setLoadingCount(c => c + 1);
        try {
            const response = await api.post(`propostas/snapshot/${params.acessorio}/acessorio/1`);
            setAcessorio({ ...acessorio, is_snapshot: true });
            alert(response.data.message, { variant: 'success' });
            history.push(`/propostas/${params.id}/modelo/${params.modelo}/acessorios`);
        } catch (error) {
            Helpers.error(error, alert);
        } finally {
            setLoadingCount(c => c - 1);
        }
    }

    async function handleAutoSave() {
        try {
            await api.post(`precos/${params.modelo}/acessorio/${params.acessorio}`, {
                ...tabela,
                ...impostos,
                ...descontos,
                lista_descadc: tabela.lista_descadc,
                lista_precoliq: getPrecoLiqKSB(),
                lista_convertido: getConvertidoKSB(),
                lista_fatdesc: getFatDescKSB(),
                lista_taxa_reais: getTaxaMoeda(),
                terceiros_precoun: getPrecoLiqTer(),
                terceiros_liquido: getPrecoBrutoSemImpostosTer(),
                terceiros_fatdesc: getFatDescTer(),
                terceiros_taxa_reais: getTaxaMoeda(),
            });
        } catch (error) {
            Helpers.error(error, alert);
        }
    }

    function handleChange(caracteristica: ICaracteristica, value: string) {
        const index = acessorio.caracteristicas.findIndex(c => c.id === caracteristica.id);
        let newCaracteristicas = acessorio.caracteristicas.map(c => { return { ...c, ultimo: false } });
        newCaracteristicas[index] = { ...caracteristica, input: value, ultimo: true, proximo: true };
        setAcessorio({ ...acessorio, caracteristicas: newCaracteristicas });
    }

    function handleChangeOption(caracteristica: ICaracteristica, value?: string) {
        if (!value || value === caracteristica.preenchido_original) return;
        const index = acessorio.caracteristicas.findIndex(c => c.id === caracteristica.id);
        const newCaracteristicas = acessorio.caracteristicas.map(c => { return { ...c, ultimo: false } });
        newCaracteristicas[index] = { ...caracteristica, preenchido: value, input: value, ultimo: true, proximo: false };
        const newAcessorio = { ...acessorio, caracteristicas: newCaracteristicas };
        setAcessorio(newAcessorio);
        handleFetchChange(newAcessorio);
    }

    function handleBlurOption(caracteristica: ICaracteristica) {
        if (caracteristica.input === caracteristica.preenchido_original) return;
        const index = acessorio.caracteristicas.findIndex(c => c.id === caracteristica.id);
        const newCaracteristicas = [...acessorio.caracteristicas];
        newCaracteristicas[index] = { ...caracteristica, preenchido: caracteristica.preenchido_original, input: caracteristica.preenchido_original };
        const newAcessorio = { ...acessorio, caracteristicas: newCaracteristicas };
        setAcessorio(newAcessorio);
    }

    function handleChangeProxima(value: string) {
        setAcessorio({
            ...acessorio,
            proxima_caracteristica: {
                ...acessorio.proxima_caracteristica,
                input: value,
                proximo: true,
            }
        });
    }

    function handleChangeOptionProxima(value?: string) {
        if (!value) return;
        const newAcessorio = {
            ...acessorio,
            proxima_caracteristica: {
                ...acessorio.proxima_caracteristica,
                preenchido: value,
                input: value,
                proximo: false,
            }
        };
        setAcessorio(newAcessorio);
        handleFetchChange(newAcessorio);
    }

    function handleBlurOptionProxima() {
        if (acessorio.proxima_caracteristica.preenchido) return;
        const newAcessorio = {
            ...acessorio,
            proxima_caracteristica: {
                ...acessorio.proxima_caracteristica,
                preenchido: '',
                input: '',
            }
        };
        setAcessorio(newAcessorio);
    }

    function handleChangePeso(caracteristica: ICaracteristica, value: string) {
        let index = acessorio.caracteristicas.indexOf(caracteristica);
        let newCaracteristicas = acessorio.caracteristicas;
        newCaracteristicas[index] = { ...caracteristica, preenchido: value };
        setAcessorio({ ...acessorio, caracteristicas: newCaracteristicas });
    }

    function handleChangePesoProxima(value: string) {
        setAcessorio({
            ...acessorio,
            proxima_caracteristica: {
                ...acessorio.proxima_caracteristica,
                preenchido: value,
            }
        });
    }

    async function handleChangeReferencia(value: string) {
        startLoading('afunilamento');
        try {
            const response = await api.post(`propostas/${params.modelo}/acessorio/${params.acessorio}`, {
                ...acessorio,
                ...impostos,
                tipo_preco: value
            });
            const { object } = response.data;
            setAcessorio(getAcessorioWithOriginal(object));
            setImpostos({
                ...object.impostos,
                fator_custo: '1',
                fator_vendas: '1'
            });
            await handleVerifyPreco(object);
        } catch (error) {
            Helpers.error(error, alert);
        } finally {
            stopLoading('afunilamento');
        }
    }

    async function handleChangeVariantes(variante: IVariante, value: any) {
        let index = variantes.indexOf(variante);
        let backupVariantes = [...variantes];
        let newVariantes = [...variantes];
        newVariantes[index] = { ...variante, selecionado: value };
        setVariantes(newVariantes);
        try {
            //Variantes
            const response = await api.post('variantes', {
                tipo_variante: 'acessorio',
                proposta_modelo: params.modelo,
                modelo_acessorio: params.acessorio,
                variantes: newVariantes
            });

            //Tabela
            const table = { ...tabela, lista_variantes: response.data.object };

            //State
            setTabela(table);

            //Auto-Save
            await api.post(`precos/${params.modelo}/acessorio/${params.acessorio}`, {
                ...table,
                ...impostos,
                ...descontos,
                lista_precoliq: getPrecoLiqKSB(table),
                lista_convertido: getConvertidoKSB(table),
                lista_fatdesc: getFatDescKSB(),
                lista_taxa_reais: getTaxaMoeda(table.moeda),
            });
        } catch (error) {
            Helpers.error(error, alert);
            setVariantes(backupVariantes);
        }
    }

    async function handleChangeCompostos(composto: IComposto, campo: ICompostoCampo, value: any, section: number) {
        let index = compostos.indexOf(composto);
        let indexCampo = compostos[index].campos.indexOf(campo);
        let backupCompostos = [...compostos];
        let newCompostos = [...compostos];
        let newCampos = newCompostos[index].campos;
        //Verifica se têm um campo anterior sem preencher
        const hasPreviousEmptyField = newCampos.slice(0, indexCampo).some(c => c.tipo === campo.tipo && !c.preenchido);
        newCampos[indexCampo] = campo.afunila === false && hasPreviousEmptyField
            ? { ...campo, preenchido: '' }
            : { ...campo, preenchido: value };
        //Verifica se é o primeiro campo afunilado do mesmo tipo
        const hasPreviousField = newCampos.slice(0, indexCampo).some(c => c.tipo === campo.tipo);
        if (campo.afunila === true && !hasPreviousField) {
            newCampos = newCampos.filter((c, i, a) => {
                const isFixed = c.nome.toLowerCase() === 'código sap' ||
                    c.nome.toLowerCase() === 'código sap' ||
                    c.nome.toLowerCase() === 'quantidade' ||
                    c.nome.toLowerCase() === 'fornecer';
                if (isFixed) return true;
                const firstAfunilaIndex = a.findIndex((d, idx) =>
                    idx <= indexCampo &&
                    d.afunila === true &&
                    d.tipo === c.tipo
                );
                if (firstAfunilaIndex === -1) return true;
                return i === firstAfunilaIndex;
            });
        }
        //Verifica se têm campos após o clicado do mesmo tipo
        const hasNextField = newCampos.slice(indexCampo + 1).some(c => c.tipo === campo.tipo);
        if (campo.afunila === false && hasNextField) {
            newCampos = newCampos.map((c, i) => {
                if (i > indexCampo && c.tipo === campo.tipo) return { ...c, preenchido: '' };
                return c;
            });
        }
        newCompostos[index] = { ...composto, campos: newCampos };
        setCompostos(newCompostos);
        if (!hasPreviousEmptyField) {
            startLoading(`compostos-${section}`);
            try {
                const response = await api.post('compostos/afunilar', {
                    infos_cabecalho: {
                        ...acessorio,
                        proposta_modelo: params.modelo,
                        modelo_acessorio: params.acessorio,
                    },
                    infos_tiques: [...newCompostos]
                });
                setCompostos(response.data.object.compostos);
                setTabela({ ...tabela, lista_variantes: response.data.object.total_variantes });
                await handleSavePrecoVariantes(response);
            } catch (error) {
                Helpers.error(error, alert);
                setCompostos(backupCompostos);
            } finally {
                stopLoading(`compostos-${section}`);
            }
        }
    }

    function handleChangeConjuntoCheckbox(checked: boolean) {
        if (checked) {
            const fator = (getValue(descontos.lista_desc_cliente)) - (getValue(descontos.lista_desc_cliente) * getValue(descontos.desc_j) / 100);
            setDescontos({
                ...descontos,
                lista_desc_cliente: fator.toFixed(4),
                cpp_desc_cliente: fator.toFixed(4),
                terceiros_desc_cliente: fator.toFixed(4),
                desc5: checked
            });
        } else {
            setDescontos({
                ...descontos,
                lista_desc_cliente: descontos.desc_cliente_original,
                cpp_desc_cliente: descontos.desc_cliente_original,
                terceiros_desc_cliente: descontos.desc_cliente_original,
                desc5: checked
            });
        }
    }

    async function handleSavePrecoVariantes(response: any) {
        try {
            await api.post(`precos/${params.modelo}/acessorio/${params.acessorio}`, {
                ...tabela,
                ...impostos,
                ...descontos,
                lista_variantes: response.data.object.total_variantes,
                lista_precoliq: getPrecoLiqKSB({ ...tabela, lista_variantes: response.data.object.total_variantes }),
                lista_convertido: getConvertido(tabela.lista_preco),
                lista_fatdesc: getFatDescKSB(),
                lista_taxa_reais: getTaxaMoeda(),
                terceiros_precoun: getPrecoLiqTer(),
                terceiros_liquido: getPrecoBrutoSemImpostosTer(),
                terceiros_fatdesc: getFatDescTer(),
                terceiros_taxa_reais: getTaxaMoeda(),
            });
        } catch (error) {
            alert('Não foi possível salvar o preço.', { variant: 'error' });
        }
    }

    async function handleCopiarEscopo() {
        if (escopoSelection) {
            startLoading('escopos');
            try {
                const response = await api.post(`propostas/${params.modelo}/copiarEscopo`, {
                    escopo_id: escopoSelection,
                    modelo_id: acessorio.modelo_id,
                    caracteristicas: acessorio.caracteristicas,
                });
                await handleSavePrecoVariantes(response);
                setCompostos(response.data.object.compostos);
                setTabela({ ...tabela, lista_variantes: response.data.object.total_variantes });
                setEscopoDialog(false);
                setEscopoSelection('');
                setPrecoResponse(true);
                alert(response.data.message, { variant: 'success' });
            } catch (error) {
                Helpers.error(error, alert);
            } finally {
                stopLoading('escopos');
            }
        }
    }

    function resetPreco() {
        setTabela({
            ...{} as ITabela,
            moeda: "R$",
            terceiros_icmsret: '0',
            terceiros_piscofinsret: '0',
            terceiros_margem_revenda: '65',
            terceiros_fatimp: '1'
        });
        setDescontos({
            ...descontos,
            desc5: false
        });
    }

    function getAcessorioWithOriginal(object: IAcessorio) {
        const value: IAcessorio = {
            ...object,
            caracteristicas: object.caracteristicas.map(c => ({
                ...c,
                preenchido_original: c.preenchido,
                input: c.preenchido
            })),
        };
        return value;
    }

    function getPesoBase() {
        if (acessorio.caracteristicas && Boolean(acessorio.isBase)) {
            const peso = acessorio.caracteristicas.find((caracteristica: ICaracteristica) =>
                caracteristica.peso_base === true
            );
            return peso && peso.preenchido ? peso.preenchido : '';
        }
        return '';
    }

    function getHerancaError(caracteristica: ICaracteristica) {
        if (caracteristica && caracteristica.tentou_herdar) {
            return `Tentou herdar o valor "${caracteristica.tentou_herdar}" mas o mesmo não estava disponível`;
        } else if (caracteristica && caracteristica.sem_heranca) {
            return caracteristica.sem_heranca === 'BOMBA' ?
                `Não foi possível herdar o valor, pois a característica está ausente no banco de dados` :
                `Não foi possivel herdar o valor, pois não há "${caracteristica.sem_heranca}" nesta bomba`;
        } else {
            return '';
        }
    }

    function getPrecoKSB() {
        return getValue(tabela.lista_preco) + getValue(tabela.lista_variantes);
    }

    function getPrecoLiqKSB(tbl: ITabela = tabela, imp: IImpostos = impostos, dsc: IDescontos = descontos, cnv: IConversao = conversao) {
        let valor_convertido = getConvertidoKSB(tbl, cnv);
        let valor_total = (getValue(valor_convertido) * getValue(getFatDescKSB(dsc)) * getValue(getFatDescAdcKSB(tbl)) / getValue(imp.fat_enc)).toFixed(2);
        return isNaNOrUndefined(valor_total) ? "0" : valor_total;
    }

    function getPrecoLiqTer(tbl: ITabela = tabela, imp: IImpostos = impostos, dsc: IDescontos = descontos, cnv: IConversao = conversao) {
        let fator_revenda = (1 / (1 - (getValue(tbl.terceiros_margem_revenda) / 100)));
        let valor_total = (getValue(getPrecoCompraTer(tbl, cnv)) * getValue(getFatDescTer(dsc)) * getValue(getFatDescAdcTer(tbl)) * fator_revenda / getValue(imp.fat_enc)).toFixed(2);
        return isNaNOrUndefined(valor_total) ? "0" : valor_total;
    }

    function getFatDescKSB(dsc: IDescontos = descontos) {
        return (getValue(dsc.lista_desc_inf_comercial) * getValue(dsc.lista_desc_cliente)).toString();
    }

    function getFatDescTer(dsc: IDescontos = descontos) {
        return (getValue(dsc.terceiros_desc_inf_comercial) * getValue(dsc.terceiros_desc_cliente)).toString();
    }

    function getFatDescAdcKSB(tbl: ITabela = tabela) {
        return (1 - (getValue(tbl.lista_descadc) / 100)).toString();
    }

    function getFatDescAdcTer(tbl: ITabela = tabela) {
        return (1 - (getValue(tbl.terceiros_desc_adicional) / 100)).toString();
    }

    function getFatRevTer() {
        return (1 / (1 - (getValue(tabela.terceiros_margem_revenda) / 100))).toFixed(2);
    }

    function getPrecoBrutoSemImpostosTer(tbl: ITabela = tabela) {
        let impostos = (1 - (getValue(tbl.terceiros_icmsret) / 100)) * (1 - (getValue(tbl.terceiros_piscofinsret) / 100));
        return ((getValue(tbl.terceiros_bruto) * impostos)).toString();
    }

    function getPrecoCompraTer(tbl: ITabela = tabela, cnv: IConversao = conversao) {
        let descforn = (1 - (getValue(tbl.terceiros_descforn) / 100));
        return (getValue(getConvertido(getPrecoBrutoSemImpostosTer(tbl), tbl.moeda, cnv)) * getValue(tbl.terceiros_fatimp) * descforn).toString();
    }

    function getConvertido(value: string, currency: string = tabela.moeda, cnv: IConversao = conversao) {
        return (getValue(value) * getValue(getTaxaMoeda(currency, cnv))).toString();
    }

    function getConvertidoKSB(tbl: ITabela = tabela, cnv: IConversao = conversao) {
        return ((getValue(tbl.lista_preco) + getValue(tbl.lista_variantes)) * getValue(getTaxaMoeda(tbl.moeda, cnv))).toString();
    }

    function getValorConvertido() {
        return Number.parseFloat(getConvertidoKSB());
    }

    function getTaxaMoeda(currency: string = tabela.moeda, cnv: IConversao = conversao) {
        let moeda = currency === "R$" ? "brl" : currency ? currency.toLowerCase() : '';
        return cnv[moeda as keyof typeof cnv];
    }

    function getLimit(value: string, min: number, max: number) {
        let num = Number.parseFloat(value);
        if (num > max) num = max;
        if (num < min) num = min;
        return !Number.isNaN(num) ? num.toString() : '';
    }

    function getValue(value: string) {
        let newValue = +value || 0;
        return newValue;
    }

    function getCaracteristicasHighlight(caracteristica: ICaracteristica) {
        if (caracteristica && caracteristica.proximo) return { notchedOutline: classes.highlightRed };
        else return {};
    }

    function isNaNOrUndefined(value: string) {
        return Number.isNaN(value) || value === undefined;
    }

    function isBaseValid() {
        if (Boolean(acessorio.isBase) && (isNaNOrUndefined(getPesoBase()) || getValue(getPesoBase()) === 0)) {
            return false;
        }
        return true;
    }

    function isCaracteristicaVisible(caracteristica: ICaracteristica) {
        const containsAt = caracteristica.preenchido === '@';
        const containsInfo = caracteristica.label.includes('INFO_');
        return !containsAt && !containsInfo ? true : false;
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Box display="flex" flexDirection="row" alignItems="center">
                    <IconButton size="small" color="primary" className={classes.backButton} onClick={() => history.push(`/propostas/${params.id}/modelo/${params.modelo}/acessorios`)}>
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" component="div">
                        {acessorio.permite_alterar ? 'Especificar Acessório' : 'Visualizar Acessório'}
                    </Typography>
                </Box>
                <Box display="flex">
                    <Box>
                        <Button
                            color="default"
                            variant="contained"
                            startIcon={<Assignment />}
                            onClick={() => setResumoDrawer(true)}>
                            Resumo
                        </Button>
                        <ResumoDrawer
                            data={resumo}
                            open={resumoDrawer}
                            error={resumoError}
                            onClose={() => setResumoDrawer(false)}
                        />
                    </Box>
                    {acessorio.permite_alterar &&
                        <React.Fragment>
                            {composto && permissions.has('proposta.copiarEscopo') &&
                                <Box ml={2}>
                                    <Button
                                        color="secondary"
                                        variant="contained"
                                        startIcon={<Layers />}
                                        onClick={() => { setEscopoDialog(true); setEscopoSelection('') }}>
                                        Copiar Escopo
                                    </Button>
                                    <Dialog open={escopoDialog} fullWidth={true} maxWidth="sm">
                                        <AppBar style={{ position: 'relative' }}>
                                            <DialogTitle>Copiar Escopo</DialogTitle>
                                            <Fade in={isLoading('escopos')} timeout={500}>
                                                <LinearProgress color="secondary"></LinearProgress>
                                            </Fade>
                                        </AppBar>
                                        <DialogContent>
                                            {escopos &&
                                                <List>
                                                    {escopos && escopos.length > 0 ? escopos.map((escopo, index) => (
                                                        <ListItem button key={index} onClick={() => setEscopoSelection(escopo.id)}>
                                                            <ListItemAvatar>
                                                                <Radio checked={escopoSelection === escopo.id} />
                                                            </ListItemAvatar>
                                                            <ListItemText
                                                                primary={`Item ${escopo.contador} - ${escopo.modelo.nome} ${escopo.tamanho ? `(${escopo.tamanho})` : ''} - ${acessorio.modelo}`}
                                                            />
                                                            <ListItemSecondaryAction>
                                                                <Link to={`/propostas/${params.id}/modelo/${escopo.id}/acessorios/${escopo.modelos[0].pivot.id}`} target="_blank" rel="noopener noreferrer">
                                                                    <IconButton edge="end">
                                                                        <OpenInNew />
                                                                    </IconButton>
                                                                </Link>
                                                            </ListItemSecondaryAction>
                                                        </ListItem>
                                                    )) :
                                                        <ListItem>
                                                            <ListItemText primary="Não existe outro escopo na proposta para ser copiado." />
                                                        </ListItem>
                                                    }
                                                </List>
                                            }
                                        </DialogContent>
                                        <DialogActions>
                                            <Button color="primary" disabled={isLoading('escopos')} onClick={() => setEscopoDialog(false)}>
                                                Fechar
                                            </Button>
                                            <Button variant="contained" color="primary" disabled={isLoading('escopos')} onClick={() => handleCopiarEscopo()}>
                                                Copiar
                                            </Button>
                                        </DialogActions>
                                    </Dialog>
                                </Box>
                            }
                            <Box ml={2}>
                                <Button
                                    color="secondary"
                                    variant="contained"
                                    startIcon={<Repeat />}
                                    onClick={() => handleReset()}>
                                    Resetar
                                </Button>
                            </Box>
                            <Box ml={2}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    startIcon={<Save />}
                                    onClick={() => handleSave()}>
                                    Salvar
                                </Button>
                            </Box>
                        </React.Fragment>
                    }
                </Box>
            </Page.Title>
            {acessorio.status &&
                <Box mb={2}>
                    <Alert severity="warning" style={{ alignItems: 'center' }}>
                        {acessorio.status}
                    </Alert>
                </Box>
            }
            {acessorio.pai &&
                <Box mb={2}>
                    <Alert
                        severity="info"
                        style={{ alignItems: 'center' }}
                        action={
                            <Button
                                variant="contained"
                                color="default"
                                startIcon={isLoading('variante') ? <CircularProgress color="inherit" size={12} /> : <OpenInNew />}
                                onClick={() => handleOpenVariantePai()}>
                                Abrir Pai
                            </Button>
                        }>
                        Esse item é uma variante, clique no botão para abrir o pai.
                    </Alert>
                </Box>
            }
            {acessorio.filho &&
                <Box mb={2}>
                    <Alert
                        severity="info"
                        style={{ alignItems: 'center' }}
                        action={
                            <Button
                                variant="contained"
                                color="default"
                                startIcon={isLoading('variante') ? <CircularProgress color="inherit" size={12} /> : <OpenInNew />}
                                onClick={() => handleOpenVariante()}>
                                Abrir Variantes
                            </Button>
                        }>
                        Esse item pode ter variantes, clique no botão para abrir.
                    </Alert>
                </Box>
            }
            <Page.Section>
                <Page.Content>
                    <Box p={2}>
                        <Box mb={2}>
                            <Box flexDirection="row" display="flex" alignItems="center">
                                <Box mr={1}>
                                    <Typography variant="h6" component="div">
                                        Dados Técnicos
                                    </Typography>
                                </Box>
                                {isLoading('afunilamento') && <CircularProgress size={12} color="inherit" />}
                            </Box>
                            <Typography variant="caption" component="div">
                                Informações técnicas do acessório e suas especificações
                            </Typography>
                        </Box>
                        <Grid container spacing={2}>
                            {!composto &&
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Referência de Preço"
                                        variant="outlined"
                                        fullWidth={true}
                                        select={true}
                                        disabled={Boolean(acessorio.apenas_terceiros) || !acessorio.permite_alterar || isLoading('afunilamento')}
                                        value={impostos.tipo_preco || ''}
                                        onChange={(event) => handleChangeReferencia(event.target.value)}
                                    >
                                        {Object.entries(tiposPrecos).map((tipoPreco) => (
                                            <MenuItem
                                                key={tipoPreco[0]}
                                                value={tipoPreco[0]}>
                                                {tipoPreco[1]}
                                            </MenuItem>
                                        ))}
                                        {/* {variante && <MenuItem value="Variantes">Lista + Variantes</MenuItem>} */}
                                    </TextField>
                                </Grid>
                            }
                            <Grid item xs={12} md={4}>
                                <TextField
                                    label="Qtd. por Bomba"
                                    variant="outlined"
                                    type="number"
                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                    fullWidth={true}
                                    disabled={!acessorio.permite_alterar}
                                    value={impostos.qtd || ''}
                                    onChange={(event) => setImpostos({ ...impostos, qtd: event.target.value })}
                                    onBlur={() => handleAutoSave()}
                                />
                            </Grid>
                            {acessorio.modelo &&
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Modelo"
                                        variant="outlined"
                                        fullWidth={true}
                                        disabled={true}
                                        value={acessorio.modelo || ''}
                                    />
                                </Grid>
                            }
                            {acessorio.caracteristicas && acessorio.caracteristicas.map((caracteristica, index) => {
                                if (isCaracteristicaVisible(caracteristica)) {
                                    if (caracteristica.peso_base) {
                                        return (
                                            <Grid key={index} item xs={12} md={4}>
                                                <Tooltip arrow={true} title="Se alterar o peso da base deverá buscar novamente o preço">
                                                    <TextField
                                                        label={caracteristica.label}
                                                        variant="outlined"
                                                        type="number"
                                                        InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                                        fullWidth={true}
                                                        disabled={acessorio.is_snapshot || !acessorio.permite_alterar}
                                                        value={caracteristica.preenchido || ''}
                                                        onChange={(event) => handleChangePeso(caracteristica, event.target.value)}
                                                        onBlur={() => handleFetchPesoBase()}
                                                    />
                                                </Tooltip>
                                            </Grid>
                                        )
                                    } else {
                                        return (
                                            <Grid key={index} item xs={12} md={4}>
                                                <Tooltip arrow={true} title={getHerancaError(caracteristica)}>
                                                    <Autocomplete
                                                        autoSelect={true}
                                                        autoHighlight={true}
                                                        clearOnBlur={false}
                                                        options={caracteristica.valores}
                                                        clearText="Limpar"
                                                        noOptionsText="Sem opções"
                                                        getOptionLabel={(option) => caracteristica.grupo
                                                            ? `${acessorio.modelo_bomba} (${option.valor})`
                                                            : option.valor
                                                        }
                                                        getOptionSelected={(option, value) => String(option.valor) === String(value.valor)}
                                                        disabled={acessorio.is_snapshot || !acessorio.permite_alterar || isLoading('afunilamento')}
                                                        inputValue={caracteristica.input || ''}
                                                        onInputChange={(_e, value) => handleChange(caracteristica, value)}
                                                        value={caracteristica.valores.find(v => String(v.valor) === String(caracteristica.preenchido)) || null}
                                                        onChange={(_e, value) => {
                                                            if (!value) return;
                                                            handleChangeOption(caracteristica, String(value?.valor))
                                                        }}
                                                        onBlur={() => handleBlurOption(caracteristica)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={caracteristica.label}
                                                                variant="outlined"
                                                                fullWidth={true}
                                                                error={getHerancaError(caracteristica) ? true : false}
                                                                InputProps={{ ...params.InputProps, classes: getCaracteristicasHighlight(caracteristica) }}
                                                            />
                                                        )}
                                                    />
                                                </Tooltip>
                                            </Grid>
                                        )
                                    }
                                } else { return null; };
                            })}
                            {acessorio.proxima_caracteristica && acessorio.proxima_caracteristica.peso_base !== true &&
                                <Grid item xs={12} md={4}>
                                    <Tooltip arrow={true} title={getHerancaError(acessorio.proxima_caracteristica)}>
                                        <Autocomplete
                                            autoSelect={true}
                                            autoHighlight={true}
                                            clearOnBlur={false}
                                            options={acessorio.proxima_caracteristica.valores}
                                            clearText="Limpar"
                                            noOptionsText="Sem opções"
                                            getOptionLabel={(option) => acessorio.proxima_caracteristica.grupo
                                                ? `${acessorio.modelo_bomba} (${option.valor})`
                                                : option.valor
                                            }
                                            getOptionSelected={(option, value) => String(option.valor) === String(value.valor)}
                                            disabled={acessorio.is_snapshot || !acessorio.permite_alterar || isLoading('afunilamento')}
                                            inputValue={acessorio.proxima_caracteristica.input || ''}
                                            onInputChange={(_e, value) => handleChangeProxima(value)}
                                            value={acessorio.proxima_caracteristica.valores.find(v => String(v.valor) === String(acessorio.proxima_caracteristica.preenchido)) || null}
                                            onChange={(_e, value) => {
                                                if (!value) return;
                                                handleChangeOptionProxima(String(value.valor))
                                            }}
                                            onBlur={() => handleBlurOptionProxima()}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={acessorio.proxima_caracteristica.label}
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    error={getHerancaError(acessorio.proxima_caracteristica) ? true : false}
                                                    InputProps={{ ...params.InputProps, classes: getCaracteristicasHighlight(acessorio.proxima_caracteristica) }}
                                                />
                                            )}
                                        />
                                    </Tooltip>
                                </Grid>
                            }
                            {acessorio.proxima_caracteristica && acessorio.proxima_caracteristica.peso_base === true &&
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label={acessorio.proxima_caracteristica.label}
                                        variant="outlined"
                                        type="number"
                                        disabled={!acessorio.permite_alterar}
                                        InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                        fullWidth={true}
                                        value={acessorio.proxima_caracteristica.preenchido || ''}
                                        onChange={(event) => handleChangePesoProxima(event.target.value)}
                                    />
                                </Grid>
                            }
                            {acessorio.codigo_sap &&
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        label="Código SAP"
                                        variant="outlined"
                                        fullWidth={true}
                                        disabled={true}
                                        value={acessorio.codigo_sap || ''}
                                    />
                                </Grid>
                            }
                            {composto &&
                                <Grid item xs={12} md={2}>
                                    <Button
                                        style={{ height: '100%' }}
                                        color="secondary"
                                        variant="contained"
                                        startIcon={<Search />}
                                        fullWidth={true}
                                        disabled={!acessorio.permite_alterar}
                                        onClick={() => handleCheckComposto()}>
                                        Buscar
                                    </Button>
                                </Grid>
                            }
                            {(impostos.tipo_preco === 'KSB' && Boolean(composto) !== true && (Boolean(acessorio.isBase) === true || Boolean(variante) === true)) &&
                                <Grid item xs={12} md={2}>
                                    <Button
                                        style={{ height: '100%' }}
                                        color="secondary"
                                        variant="contained"
                                        startIcon={<Search />}
                                        fullWidth={true}
                                        disabled={!acessorio.permite_alterar}
                                        onClick={() => handleCheckPreco()}>
                                        Buscar Preço
                                    </Button>
                                </Grid>
                            }
                            <Dialog open={buscarCompostoDialog} onClose={() => setBuscarCompostoDialog(false)}>
                                <DialogTitle>Buscar</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        Ao buscar, se houver valores preenchidos eles podem ser resetados, continuar?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setBuscarCompostoDialog(false)} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={() => handleFetchComposto()} color="primary" autoFocus>
                                        Continuar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog open={buscarDialog} onClose={() => setBuscarDialog(false)}>
                                <DialogTitle>Buscar Preço</DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        Ao buscar a precificação, se houver valores preenchidos eles podem ser resetados, continuar?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setBuscarDialog(false)} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={() => handleSearchPreco()} color="primary" autoFocus>
                                        Continuar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Grid>
                        {composto && compostos && compostos.length > 0 &&
                            <React.Fragment>
                                <Box mt={2} mb={1}>
                                    <Divider></Divider>
                                </Box>
                                <Box mb={2}>
                                    <Typography style={{ textTransform: 'capitalize' }} variant="h6" component="div">
                                        {`${acessorio.modelo}`}
                                    </Typography>
                                </Box>
                                {compostos && compostos.map((composto, index) => (
                                    <React.Fragment key={index}>
                                        <Box my={2}>
                                            <Box flexDirection="row" display="flex" alignItems="center">
                                                <Box mr={1}>
                                                    <Typography style={{ textTransform: 'capitalize', fontWeight: 'bold' }} variant="subtitle1" component="div">
                                                        {composto.descricao}
                                                    </Typography>
                                                </Box>
                                                {isLoading(`compostos-${index}`) && <CircularProgress size={12} color="inherit" />}
                                            </Box>
                                            <Divider></Divider>
                                        </Box>
                                        <Grid style={{ marginBottom: theme.spacing(2) }} container spacing={2}>
                                            {composto.campos && composto.campos.map((campo, i) => {
                                                if (campo.tipo === "checkbox") {
                                                    return (
                                                        <Grid key={i} item xs={12} md={3}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={Boolean(campo.preenchido)}
                                                                        disabled={!acessorio.permite_alterar || isLoading(`compostos-${index}`)}
                                                                        onChange={(event) => handleChangeCompostos(composto, campo, event.target.checked, index)}
                                                                    />
                                                                }
                                                                label={campo.nome}
                                                            />
                                                        </Grid>
                                                    );
                                                } else { return null; }
                                            })}
                                        </Grid>
                                        <Grid container direction="row" spacing={2}>
                                            {composto.campos && composto.campos.map((campo, i) => {
                                                if (campo.tipo === "dropdown") {
                                                    return (
                                                        <Grid key={i} item xs={12} md={3}>
                                                            <Grid style={{ marginBottom: theme.spacing(2) }} container direction="column" spacing={1}>
                                                                <Grid item xs={12}>
                                                                    <FormLabel component="legend">{campo.nome.toUpperCase()}</FormLabel>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextField
                                                                        placeholder={campo.nome}
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        select={true}
                                                                        disabled={!acessorio.permite_alterar || isLoading(`compostos-${index}`)}
                                                                        value={campo.preenchido || ''}
                                                                        onChange={(event) => handleChangeCompostos(composto, campo, event.target.value, index)}
                                                                    >
                                                                        {campo.opcoes && campo.opcoes.map((opcao, j) => (
                                                                            <MenuItem key={j} value={opcao.opcao}>{opcao.opcao}</MenuItem>
                                                                        ))}
                                                                    </TextField>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    );
                                                } else { return null; }
                                            })}
                                            {composto.campos && composto.campos.map((campo, i) => {
                                                if (campo.tipo === "text") {
                                                    return (
                                                        <Grid key={i} item xs={12} md={3}>
                                                            <Grid style={{ marginBottom: theme.spacing(2) }} container direction="column" spacing={1}>
                                                                <Grid item xs={12}>
                                                                    <FormLabel component="legend">{campo.nome.toUpperCase()}</FormLabel>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <TextField
                                                                        placeholder={campo.nome}
                                                                        variant="outlined"
                                                                        fullWidth={true}
                                                                        disabled={(campo.nome.toLowerCase() === 'código sap' ? true : false) || !acessorio.permite_alterar || isLoading(`compostos-${index}`)}
                                                                        value={campo.preenchido || ''}
                                                                        onChange={(event) => handleChangeCompostos(composto, campo, event.target.value, index)}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    );
                                                } else { return null; }
                                            })}
                                        </Grid>
                                        <Grid container spacing={2}>
                                            {composto.campos && composto.campos.map((campo, i) => {
                                                if (campo.tipo === "radio") {
                                                    return (
                                                        <Grid key={i} item xs={12} md={3}>
                                                            <FormControl component="fieldset">
                                                                <FormLabel component="legend">{campo.nome.toUpperCase()}</FormLabel>
                                                                <RadioGroup value={campo.preenchido || ''}>
                                                                    {campo.opcoes && campo.opcoes.map((opcao, j) => (
                                                                        <FormControlLabel
                                                                            key={j}
                                                                            value={opcao.opcao}
                                                                            disabled={!acessorio.permite_alterar || isLoading(`compostos-${index}`)}
                                                                            control={
                                                                                <Radio
                                                                                    onClick={() => {
                                                                                        const value = campo.preenchido === opcao.opcao ? '' : opcao.opcao;
                                                                                        handleChangeCompostos(composto, campo, value, index)
                                                                                    }}
                                                                                />
                                                                            }
                                                                            label={opcao.opcao}
                                                                        />
                                                                    ))}
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Grid>
                                                    );
                                                } else { return null; }
                                            })}
                                        </Grid>
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        }
                        {impostos.tipo_preco &&
                            <React.Fragment>
                                {impostos.tipo_preco === "Variantes" && precoResponse &&
                                    <React.Fragment>
                                        <Box mt={2} mb={1}>
                                            <Divider></Divider>
                                        </Box>
                                        <Box my={2}>
                                            <Typography variant="h6" component="div">
                                                Variantes
                                            </Typography>
                                        </Box>
                                        <Grid container spacing={2}>
                                            {variantes && variantes.map((variante, index) => {
                                                if (variante.tipo === "dropdown") {
                                                    return (
                                                        <Grid key={index} item xs={12} md={4}>
                                                            <TextField
                                                                label={variante.label}
                                                                variant="outlined"
                                                                fullWidth={true}
                                                                select={true}
                                                                disabled={!acessorio.permite_alterar}
                                                                value={variante.selecionado || ''}
                                                                onChange={(event) => handleChangeVariantes(variante, event.target.value)}
                                                            >
                                                                {variante.opcoes && variante.opcoes.map((opcao, i) => (
                                                                    <MenuItem key={i} value={opcao.id}>{opcao.opcao}</MenuItem>
                                                                ))}
                                                            </TextField>
                                                        </Grid>
                                                    );
                                                } else { return null; }
                                            })}
                                        </Grid>
                                        <Box my={2}>
                                            <Divider />
                                        </Box>
                                        <Grid container spacing={2}>
                                            {variantes && variantes.map((variante, index) => {
                                                if (variante.tipo === "radio") {
                                                    return (
                                                        <Grid key={index} item xs={12} md={4}>
                                                            <FormControl component="fieldset">
                                                                <FormLabel component="legend">{variante.label}</FormLabel>
                                                                <RadioGroup value={variante.selecionado?.toString() || ''} onChange={(event) => handleChangeVariantes(variante, (event.target as HTMLInputElement).value)}>
                                                                    {variante.opcoes && variante.opcoes.map((opcao, i) => (
                                                                        <FormControlLabel
                                                                            key={i}
                                                                            value={opcao.id.toString()}
                                                                            disabled={!acessorio.permite_alterar}
                                                                            control={<Radio />}
                                                                            label={opcao.opcao}
                                                                        />
                                                                    ))}
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Grid>
                                                    );
                                                } else { return null; }
                                            })}
                                        </Grid>
                                        <Box my={2}>
                                            <Divider />
                                        </Box>
                                        <Grid container spacing={2} alignContent="center">
                                            {variantes && variantes.map((variante, index) => {
                                                if (variante.tipo === "checkbox") {
                                                    return (
                                                        <Grid key={index} item xs={12} md={4}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={Boolean(variante.selecionado)}
                                                                        disabled={!acessorio.permite_alterar}
                                                                        onChange={(event) => handleChangeVariantes(variante, event.target.checked === true ? variante.id : '')}
                                                                    />
                                                                }
                                                                label={variante.label}
                                                            />
                                                        </Grid>
                                                    );
                                                } else { return null; }
                                            })}
                                        </Grid>
                                    </React.Fragment>
                                }
                                {(impostos.tipo_preco === "KSB" || impostos.tipo_preco === "Variantes") && precoResponse &&
                                    <React.Fragment>
                                        <Box mt={2} mb={1}>
                                            <Divider></Divider>
                                        </Box>
                                        <Box mb={2}>
                                            <Typography variant="h6" component="div">
                                                Lista KSB
                                            </Typography>
                                            <Typography variant="caption" component="div">
                                                Exibe os valores de precificação da bomba do tipo Lista KSB
                                            </Typography>
                                        </Box>
                                        <Grid container spacing={2}>
                                            {(impostos.tipo_preco === "Variantes" || composto) &&
                                                <Grid item xs={12} md={4}>
                                                    <CurrencyInput
                                                        hideSymbol={true}
                                                        value={tabela.lista_variantes ? Number.parseFloat(tabela.lista_variantes) : "0"}
                                                        InputElement={
                                                            <TextField
                                                                label={composto ? 'Total Compostos' : 'Total Variantes'}
                                                                variant="outlined"
                                                                fullWidth={true}
                                                                disabled={true}
                                                            />
                                                        }
                                                    />
                                                </Grid>
                                            }
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Moeda"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={tabela.moeda || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={getPrecoKSB() ? getPrecoKSB() : "0"}
                                                    InputElement={
                                                        <TextField
                                                            label="Preço Un. Bruto Sem IPI"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={getValorConvertido() ? getValorConvertido() : "0"}
                                                    InputElement={
                                                        <TextField
                                                            label="Valor Convertido"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Inf. Comercial"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={descontos.lista_desc_inf_comercial || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Cliente"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={descontos.lista_desc_cliente || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Desc."
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getFatDescKSB()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Adicional (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.lista_descadc || ''}
                                                    onChange={(event) => setTabela({ ...tabela, lista_descadc: getLimit(event.target.value, 0, 100) })}
                                                    onBlur={() => handleAutoSave()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Desc. Adicional"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getValue(getFatDescAdcKSB()).toFixed(2)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(getPrecoLiqKSB()) ? Number.parseFloat(getPrecoLiqKSB()) : "0"}
                                                    InputElement={
                                                        <TextField
                                                            label="Preço Un. Líquido de Venda"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={Boolean(descontos.desc5)}
                                                            disabled={!acessorio.permite_alterar}
                                                            onChange={(event) => handleChangeConjuntoCheckbox(event.target.checked)}
                                                            onBlur={() => handleAutoSave()}
                                                        />
                                                    }
                                                    label="Aplicar Desconto de Conjunto"
                                                />
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                }
                                {impostos.tipo_preco === "Terceiros" &&
                                    <React.Fragment>
                                        <Box mt={2} mb={1}>
                                            <Divider></Divider>
                                        </Box>
                                        <Box mb={2}>
                                            <Typography variant="h6" component="div">
                                                Cotação
                                            </Typography>
                                            <Typography variant="caption" component="div">
                                                Exibe os valores de precificação da bomba do tipo Cotação
                                            </Typography>
                                        </Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fornecedor"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.terceiros_fornecedor || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_fornecedor: event.target.value })}
                                                    onBlur={() => handleAutoSave()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Referência Fornecedor"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.terceiros_referencia || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_referencia: event.target.value })}
                                                    onBlur={() => handleAutoSave()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Moeda"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    select={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.moeda || ''}
                                                    onChange={(event) => setTabela({ ...tabela, moeda: event.target.value })}
                                                    onBlur={() => handleAutoSave()}
                                                >
                                                    <MenuItem value="R$">R$</MenuItem>
                                                    <MenuItem value="EUR">EUR</MenuItem>
                                                    <MenuItem value="USD">USD</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(tabela.terceiros_bruto)}
                                                    onChangeValue={(_e, ov) => setTabela({ ...tabela, terceiros_bruto: ov.toString() })}
                                                    onBlur={() => handleAutoSave()}
                                                    InputElement={
                                                        <TextField
                                                            label="Preço Un. Bruto Sem IPI"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={!acessorio.permite_alterar}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="ICMS à Retirar"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    select={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.terceiros_icmsret || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_icmsret: event.target.value })}
                                                    onBlur={() => handleAutoSave()}
                                                >
                                                    <MenuItem value="0">0</MenuItem>
                                                    <MenuItem value="7">7</MenuItem>
                                                    <MenuItem value="12">12</MenuItem>
                                                    <MenuItem value="13.3">13.3</MenuItem>
                                                    <MenuItem value="18">18</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="PIS/COFINS à Retirar"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    select={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.terceiros_piscofinsret || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_piscofinsret: event.target.value })}
                                                    onBlur={() => handleAutoSave()}
                                                >
                                                    <MenuItem value="0">0</MenuItem>
                                                    <MenuItem value="9.25">9.25</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator de Importação"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.terceiros_fatimp || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_fatimp: event.target.value })}
                                                    onBlur={() => handleAutoSave()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desconto Fornecedor (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.terceiros_descforn || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_descforn: getLimit(event.target.value, 0, 100) })}
                                                    onBlur={() => handleAutoSave()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={Number.parseFloat(getPrecoCompraTer())}
                                                    InputElement={
                                                        <TextField
                                                            label="Preço Un. Líquido de Compra"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Inf. Comercial"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={descontos.terceiros_desc_inf_comercial || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Cliente"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={descontos.terceiros_desc_cliente || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Desc."
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getFatDescTer()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Desc. Adicional (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, max: 100, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.terceiros_desc_adicional || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_desc_adicional: getLimit(event.target.value, 0, 100) })}
                                                    onBlur={() => handleAutoSave()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Desc. Adicional"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getValue(getFatDescAdcTer()).toFixed(2)}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Margem de Revenda (%)"
                                                    variant="outlined"
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 0, step: 'any' } }}
                                                    fullWidth={true}
                                                    disabled={!acessorio.permite_alterar}
                                                    value={tabela.terceiros_margem_revenda || ''}
                                                    onChange={(event) => setTabela({ ...tabela, terceiros_margem_revenda: event.target.value })}
                                                    onBlur={() => handleAutoSave()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Revenda"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={getFatRevTer()}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <CurrencyInput
                                                    hideSymbol={true}
                                                    value={getPrecoLiqTer()}
                                                    InputElement={
                                                        <TextField
                                                            label="Preço Un. Líquido de Venda"
                                                            variant="outlined"
                                                            fullWidth={true}
                                                            disabled={true}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                }
                                {!composto && (data.user.papel === 4 || data.user.papel === 3 || data.user.papel === 5) &&
                                    <React.Fragment>
                                        <Box mt={2} mb={1}>
                                            <Divider></Divider>
                                        </Box>
                                        <Box mb={2}>
                                            <Typography variant="h6" component="div">
                                                Fatores
                                            </Typography>
                                            <Typography variant="caption" component="div">
                                                Modificadores de preço para cálculo de valor de venda no memorial
                                            </Typography>
                                        </Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator de Vendas"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={impostos.fator_vendas + '' || ''}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    label="Fator Custo Material"
                                                    variant="outlined"
                                                    fullWidth={true}
                                                    disabled={true}
                                                    value={impostos.fator_custo + '' || ''}
                                                />
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                }
                            </React.Fragment>
                        }
                    </Box>
                </Page.Content>
            </Page.Section>
        </Page>
    );
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backButton: {
            marginRight: theme.spacing(1),
        },
        row: {
            marginBottom: theme.spacing(1)
        },
        custom: {
            padding: '2px 4px',
            display: 'flex',
            alignItems: 'center',
        },
        input: {
            marginLeft: theme.spacing(1),
            flex: 1,
        },
        highlightRed: {
            borderColor: red[500],
        }
    })
);

export default PropostasAcessoriosModelo;